import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { USER_INACTIVITY_MAX_TIME } from '../ecommerce-generico/constants';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {

  private worker: Worker = new Worker(new URL('./idle-timeout.worker', import.meta.url), { type: 'module' });
  private inactivityDetectedSubject = new Subject<void>();
  inactivityDetected$ = this.inactivityDetectedSubject.asObservable();

  constructor() {
    this.worker.addEventListener('message', (avisoDesdeWebworker) => {
      if (avisoDesdeWebworker.data === 'INACTIVIDAD DETECTADA') {
        this.inactivityDetectedSubject.next();
      }
    });
  }

  /**
   * reinicia el contador de inactividad, si el usuario no realiza ninguna peticion en USER_INACTIVITY_MAX_TIME ms se emite inactivityDetected$
   */
  restart(): void {
    this.worker.postMessage(JSON.stringify({ tiempo: USER_INACTIVITY_MAX_TIME }));
  }
}
